import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'src/store/components/axiosInstance';
import createDataSlice from 'src/store/components/createDataSlice';
import saveToRedux from 'src/store/components/saveToRedux';

const modelName = 'Property';
const tableName = 'properties';
const pathName = 'properties';

export const findRecords = createAsyncThunk(
  `${modelName}s/find${pathName}s`,
  async (propertyUid, { rejectWithValue }) => {
    const response = await axiosInstance.get(pathName + `/find/${propertyUid}`);
    console.log('Response data', response.data);
    return response.data;
  }
);

const initialState = {
  data: [], // Array to store Referral Point
  message: '', // Message from API response
  nextPageUrl: null,
  prevPageUrl: null,
  total: 0,
  loading: false,
};

const extraReducers = (builder) => {
  // API fetching state
  builder.addCase(findRecords.pending, (state) => {
    state.loading = true; // Set loading true to show loading screen
  });

  // API response received state (SUCCESS)
  builder.addCase(findRecords.fulfilled, (state, action) => {
    // Assuming action.payload is the response from the API
    saveToRedux(state, action.payload); // Saving districts to redux
    state.loading = false; // Set loading false to hide loading screen
  });

  // API response received state (FAILURE)
  builder.addCase(findRecords.rejected, (state, action) => {
    state.message = action.payload?.message || `Failed to fetch ${modelName}s!`;
    state.loading = false; // Set loading false to hide loading screen
  });
};

export const dataSlice = createDataSlice(
  tableName,
  extraReducers,
  initialState
);
export default dataSlice.reducer;
